import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { WA_NUMBER } from '../data/products';
interface NavbarProps {
  onBrandFilter?: (brand: string | null) => void;
}
export function Navbar({
  onBrandFilter
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isBrandsOpen, setIsBrandsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setIsBrandsOpen(false);
  };
  const handleBrandClick = (brand: string) => {
    if (onBrandFilter) {
      onBrandFilter(brand);
    }
    closeMenu();
    // Smooth scroll to products section
    setTimeout(() => {
      const productsSection = document.getElementById('productos');
      if (productsSection) {
        productsSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  const navLinks = [{
    href: '#productos',
    label: 'Productos'
  }, {
    href: '#combos',
    label: 'Combos'
  }, {
    href: '#nosotros',
    label: 'Nosotros'
  }, {
    href: '#faq',
    label: 'FAQ'
  }, {
    href: '#envios',
    label: 'Envíos'
  }, {
    href: '#ubicacion',
    label: 'Ubicación'
  }, {
    href: `https://wa.me/${WA_NUMBER}`,
    label: 'WhatsApp',
    external: true
  }];
  return <nav className="bg-dark-700 border-b-2 border-alphaGold py-4 px-5 relative z-50" data-id="element-216">
      <div className="max-w-[1100px] mx-auto flex justify-between items-center" data-id="element-217">
        <a href="#" className="flex items-center" onClick={closeMenu} data-id="element-218">
          <img src="https://cdn.magicpatterns.com/uploads/o9QuWRFj9QDHop4MmMKe7L/Logo_-_Editado.png" alt="AlphaFit" className="h-8 md:h-10 object-contain" onError={e => {
          // Fallback to text if logo is missing
          e.currentTarget.style.display = 'none';
          e.currentTarget.nextElementSibling?.classList.remove('hidden');
        }} data-id="element-219" />
          <span className="hidden text-2xl font-black text-alphaGold tracking-[3px] uppercase" data-id="element-220">
            Alpha<span className="text-white" data-id="element-221">Fit</span>
          </span>
        </a>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-6 list-none" data-id="element-222">
          <li data-id="element-223">
            <a href="#productos" onClick={() => onBrandFilter && onBrandFilter(null)} className="text-[#ddd] no-underline text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold" data-id="element-224">
              Productos
            </a>
          </li>

          {/* Marcas Dropdown Desktop */}
          <li className="relative group" data-id="element-225">
            <button className="flex items-center gap-1 text-[#ddd] text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold py-2" data-id="element-226">
              Marcas{' '}
              <ChevronDown size={16} className="transition-transform group-hover:rotate-180" data-id="element-227" />
            </button>
            <div className="absolute top-full left-0 w-48 bg-dark-700 border border-dark-500 rounded-md shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 translate-y-2 group-hover:translate-y-0 overflow-hidden" data-id="element-228">
              <button onClick={() => handleBrandClick('Cibeles')} className="w-full text-left px-4 py-3 text-white hover:bg-dark-600 hover:text-alphaGold transition-colors border-b border-dark-500 font-medium" data-id="element-229">
                Cibeles
              </button>
              <button onClick={() => handleBrandClick('Profit')} className="w-full text-left px-4 py-3 text-white hover:bg-dark-600 hover:text-alphaGold transition-colors font-medium" data-id="element-230">
                Profit
              </button>
            </div>
          </li>

          {navLinks.slice(1).map(link => <li key={link.label} data-id="element-231">
              <a href={link.href} target={link.external ? '_blank' : '_self'} rel={link.external ? 'noopener noreferrer' : ''} className="text-[#ddd] no-underline text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold" data-id="element-232">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2 focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-233">
          {isOpen ? <X size={28} data-id="element-234" /> : <Menu size={28} data-id="element-235" />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && <div className="md:hidden absolute top-full left-0 w-full bg-dark-700 border-b border-dark-400 shadow-xl py-4 px-5 flex flex-col gap-2" data-id="element-236">
          <a href="#productos" onClick={e => {
        if (onBrandFilter) onBrandFilter(null);
        closeMenu();
      }} className="text-[#ddd] no-underline text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold block py-2 border-b border-dark-500" data-id="element-237">
            Productos
          </a>

          {/* Marcas Accordion Mobile */}
          <div className="border-b border-dark-500" data-id="element-238">
            <button onClick={() => setIsBrandsOpen(!isBrandsOpen)} className="w-full flex items-center justify-between text-[#ddd] text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold py-2" data-id="element-239">
              Marcas
              <ChevronDown size={20} className={`transition-transform duration-300 ${isBrandsOpen ? 'rotate-180' : ''}`} data-id="element-240" />
            </button>

            <div className={`overflow-hidden transition-all duration-300 ${isBrandsOpen ? 'max-h-40 opacity-100 mb-2' : 'max-h-0 opacity-0'}`} data-id="element-241">
              <button onClick={() => handleBrandClick('Cibeles')} className="w-full text-left pl-4 py-2 text-[#aaa] hover:text-alphaGold transition-colors text-base font-medium" data-id="element-242">
                • Cibeles
              </button>
              <button onClick={() => handleBrandClick('Profit')} className="w-full text-left pl-4 py-2 text-[#aaa] hover:text-alphaGold transition-colors text-base font-medium" data-id="element-243">
                • Profit
              </button>
            </div>
          </div>

          {navLinks.slice(1).map(link => <a key={link.label} href={link.href} target={link.external ? '_blank' : '_self'} rel={link.external ? 'noopener noreferrer' : ''} onClick={closeMenu} className="text-[#ddd] no-underline text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold block py-2 border-b border-dark-500 last:border-0" data-id="element-244">
              {link.label}
            </a>)}
        </div>}
    </nav>;
}